import r from "./_getLength.js";
import t from "./contains.js";
function o(o) {
  for (var n = [], e = arguments.length, f = 0, i = r(o); f < i; f++) {
    var s,
      a = o[f];
    if (!t(n, a)) {
      for (s = 1; s < e && t(arguments[s], a); s++);
      s === e && n.push(a);
    }
  }
  return n;
}
export { o as default };